import * as angular from "angular";
import {IController, ILogService} from "angular";
import {AgentInventoryDialogService} from "../../angular/services/agent-inventory-dialog.service";
import {AgentInventoryRequestsService} from "../../services/agent-inventory-requests.service";
import {BringozToastService} from "../../../commons/services/bringoz-toast.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";

export class AgentInventoryTransactionsTableComponent implements IController {

  infiniteScroll: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

  $onChanges(changes: angular.IOnChangesObject) {

  }

}

angular
  .module('bringoz.admin.agent-inventory')
  .component('agentInventoryTransactionsTable', {
    bindings: {
      infiniteScroll: '<'
    },
    template: require('./agent-inventory-transactions-table.html').default,
    controller: AgentInventoryTransactionsTableComponent
  });

